<template>
  <div>
    <h1>Editar Concedente_contato</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("concedentes_contatos", ["concedente_contato"]),
  },
  methods: {
    ...mapActions("concedentes_contatos", [
      "ActionNewConcedente_contato",
      "ActionShow",
    ]),
    async loadData(id) {
      try {
        await this.ActionShow(id);
      } catch (error) {
        this.$notifications.addNotification({
          message: error.data.responseMessage,
          icon: "exclamation-triangle",
          type: "danger",
        });
        this.$router.push({ name: "concedentes_contatos_list" });
      }
    },
  },
  async created() {
    this.ActionNewConcedente_contato();
    await this.loadData(this.$route.params.id);
  },
};
</script>

<style></style>
